import jwtAuthAxios from "./auth/jwtAuth";

// Plugins de la empresa activa. La página maneja sus propios errores (silentErrors) para mostrarlos donde corresponde.
const pluginServices = {};

// Todos los plugins, con su estado en la empresa (disponible, instalado, activo, configuración).
pluginServices.getPlugins = async () => {
    const {data} = await jwtAuthAxios.get("/plugins");
    return data;
};

// activate: instalarlo y activarlo de una vez, si no le falta configuración.
pluginServices.togglePluginInstallation = async (id, { activate = false } = {}) => {
    const {data} = await jwtAuthAxios.post(`/plugins/${id}/toggle_installation`, { activate }, { silentErrors: true });
    return data;
};

pluginServices.togglePluginActivation = async (id) => {
    const {data} = await jwtAuthAxios.post(`/plugins/${id}/toggle_activation`, {}, { silentErrors: true });
    return data;
};

pluginServices.saveConfig = async (id, params) => {
    const {data} = await jwtAuthAxios.post(`/plugins/${id}/set_config`, params, { silentErrors: true });
    return data;
};

pluginServices.requestPlugin = async (params) => {
    const {data} = await jwtAuthAxios.post('/plugin_requests', params, { silentErrors: true });
    return data;
};

export default pluginServices;
